import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=6235735c&scoped=true&"
import script from "./SiteFooter.vue?vue&type=script&lang=js&"
export * from "./SiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=6235735c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235735c",
  null
  
)

export default component.exports